// @flow

import React from 'react';
import { observer } from 'mobx-react';
import FlipMove from 'react-flip-move';
import { css } from 'glamor';
import { Col } from 'react-bootstrap';

import type { Platform as PlatformType } from '~/types';
import Platform from '~/components/content/platform/Platform';

const rule = css({
    height: '210px',
    marginTop: '15px',

    '@media(max-width: 768px)': {
        height: '100%',
    },
});

@observer
export default class PlatformList extends React.Component {
    props: {
        platforms: Array<PlatformType>,
    };

    render() {
        const { platforms } = this.props;

        return (
            <ul className="list-unstyled">
                <FlipMove
                    easing="ease-in-out"
                    enterAnimation="fade"
                    leaveAnimation="fade"
                >
                    {platforms.map(platform => (
                        <Col md={ 6 } key={ platform.id }>
                            <li { ...rule }>
                                <Platform platform={ platform } />
                            </li>
                        </Col>
                    ))}
                </FlipMove>
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/platform/PlatformList/index.js